import Router from 'vue-router'

/**
 * @Author:
 * @Description:
 * @DateTime: Created in 13:41 2020/12/4
 */
	// 路由配置
const RouterConfig: any = {
		mode: 'hash',
		routes: []
	}
let routerInstance = new Router(RouterConfig)
export default routerInstance